import { useQuery } from '@tanstack/react-query'
import { getContentStep, ContentStepDTO } from '../apis/api-content'

export const useStepContent = (stepId?: string) => {
    const queryKey = ['Step Content', stepId]

    const { data: stepContent, isLoading, error, ...rest } = useQuery<ContentStepDTO>({
        queryKey,
        queryFn: async () => {
            if (!stepId) {
                return Promise.reject('No step ID provided')
            }
            
            console.log(`🔄 Fetching step content for step ID: ${stepId}`)
            return getContentStep(stepId)
        },
        enabled: !!stepId,
        // Longer caching for study plan content since it rarely changes
        staleTime: 1000 * 60 * 60, // Consider data fresh for 60 minutes (longer than global setting)
        gcTime: 1000 * 60 * 120,   // Keep unused data in cache for 2 hours
        // Don't refetch unnecessarily
        refetchOnMount: false,
        refetchOnReconnect: false,
    })

    return {
        stepContent,
        isLoading,
        error,
        ...rest,
    }
} 